export const BASE = {
  company: {
    logo: "https://storage.googleapis.com/companies-assets/ingresse/logo-ingresse-gray.png",
    background_image: "https://storage.googleapis.com/companies-assets/ingresse/bg-onboarding-ingresse.png",
    primaryColor: "#016940",
    secondaryColor: "#8f0028",
    tertiaryColor: "#541b10",
    copyrightLogo: "default",
    backgroundColor: ["#000000", "#000000"],
    tenant: 'ingresse-yyyho',
    name: 'Ingresse',
    bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
    id: '2cfe1777-1bad-4252-9a0d-b9f5d8bbaac3',
    dis: 0.87
  }
}